import React from 'react'
import JobApplyBody from '../components/jobApply/JobApplyBody'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'

const JobApply = () => {
  return (
    <div>
      <Navbar></Navbar>
      <JobApplyBody></JobApplyBody>
      <Footer></Footer>
    </div>
  )
}

export default JobApply
